import {React, useEffect, useState, Fragment} from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {Paper, Grid, Typography, TextField, MenuItem, Zoom, Table, TableBody, TableHead, TableContainer, TableCell, TableRow, 
        Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Switch} from '@material-ui/core/'
import AddIcon from '@material-ui/icons/Add';
import {authFetch, logout} from '../../auth';

import MarketName from '@material-ui/icons/CalendarViewDay';
import Area from '@material-ui/icons/CropFree';
import State from '@material-ui/icons/RadioButtonChecked';
import EventIcon from '@material-ui/icons/Event';
import CodeIcon from '@material-ui/icons/ListAlt';
import {DatePicker} from '@material-ui/pickers';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import Incum from '@material-ui/icons/Layers';
import Agent from '@material-ui/icons/SortByAlpha';
import ORCode from '@material-ui/icons/SettingsEthernet';
import { set } from 'date-fns';
import DomainIcon from '@material-ui/icons/Domain';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      padding: 3
    },
    body: {
      fontSize: 14,
      color: theme.palette.primary.dark,
      padding: 5
    },
  }))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    formPaper: {
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        "> * + *": {
            marginTop: theme.spacing(5)
        }
    }, 
    formRow: {
        width: "100%",       
        maxHeight: "50%",        
    },
    labelText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16 
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
        marginLeft: theme.spacing(1)
    },
    formDefined: {
        backgroundColor: theme.palette.secondary.light,        
    },
    formDateText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
    },
    formItemNoPadding: {
        padding: 0
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    }
  }));
  
export default function Summary(props) {
    const classes = useStyles();    
    //const [inputPeriod, setInputPeriod] = useState(periods[actualMonth-1]);
 
    const [actorDialog, setActorDialog] = useState(false) 
    const [feedbackDialog, setFeedbackDialog] = useState(false) 
    const [feedbackMsg, setFeedbackMsg] = useState("")

    const [portfoliosList, setPortfoliosList] = useState([])
    const [portfolioData, setPortfolioData] = useState({})

    const [comCalcMethods, setComCalcMethods] = useState([])
    const [genCalcMethods, setGenCalcMethods] = useState([])

    const handleActorDialogOpen = () => {
        setActorDialog(true);
      };
    
    const handleActorDialogClose = () => {
        setActorDialog(false);
    };

    const handleFeedbackDialogOpen = () => {
        setFeedbackDialog(true);
      };
    
    const handleFeedbackDialogClose = () => {
        setFeedbackDialog(false);
    };

    const updateValuesWithSelectedActor = (idx) => {
        if (idx === -1){
            setPortfolioData({active: true})
        }
        else{
            setPortfolioData(portfoliosList[idx])
        }
    }
    
    const handleActorUpload = () => {     
        //console.log(conceptData)   
        if (!portfolioData.name || !portfolioData.description){            
            handleFeedbackDialogOpen()
            setFeedbackMsg("Algunos campos estan vacíos. Ingreso inválido.")
        }   
        else {            
            if (!portfolioData['id']){
                portfolioData['username'] = props.username
            }            
            authFetch(
            "/api/update-portfolios",
            {
                method: 'post',
                body: JSON.stringify(portfolioData),
            }
            ).then(r => {
              if (r.status === 422){
                logout()
                return null
              }
              else{
                return r.json()
              }
            })
            .then(response => {
                if (response.Upload === 'OK'){
                setFeedbackMsg('Datos guardados. Verifique la información reflejada en la lista.')
                handleFeedbackDialogOpen()
                handleActorDialogClose()
                authFetch("/api/check-portfolios-list?username="+props.username).then(response => {
                    if (response.status === 422){
                        logout()
                        return null
                    }
                        return response.json()
                    }).then(response => {
                        if (response && response.portfolios){                    
                            setPortfoliosList(response.portfolios)
                        }
                    })
                }
                else {
                    setFeedbackMsg('Error al guardar los datos.')
                    handleFeedbackDialogOpen()
                }
            })
        }     
    }

    const showFeedbackDialog = () => (
        <Dialog
            open={feedbackDialog}
            onClose={handleFeedbackDialogClose}       
            className={classes.formText}            
        >
        <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>Aviso</DialogTitle>
        <DialogContent className={classes.dialogContent}>
            <DialogContentText>
                {feedbackMsg}
            </DialogContentText>
        </DialogContent>
        <DialogActions>          
          <Button onClick={handleFeedbackDialogClose} color="primary" autoFocus>
            Aceptar
          </Button>
        </DialogActions>
        </Dialog>
    )
 
    const showActorDialog = () => (
        <Dialog
            open={actorDialog}
            onClose={handleActorDialogClose}       
            className={classes.formText}
            scroll={'paper'}
            maxWidth={'md'}
        >
        <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>{"Ingresar/Revisar los datos del portafolio."}</DialogTitle>
        <DialogContent className={classes.dialogContent}>                     
            <Grid container spacing={1} alignItems="flex-start" justify="space-evenly">                
                <Grid item xs={6}>
                    <Grid container spacing={2}>                        
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Portafolio</Typography>
                        </Grid>
                        <Grid item>
                            <DomainIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                disabled={portfolioData.id ? true : false}                    
                                value={portfolioData.name}
                                placeholder={"Empresa/Código"}
                                InputProps={{
                                    readOnly: portfolioData.id ? true : false,
                                    className:portfolioData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow}   
                                onChange={(e) => setPortfolioData({...portfolioData, name: e.target.value})}                            
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Subportafolio:</Typography>
                        </Grid>
                        <Grid item>
                            <BusinessCenterIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                disabled={portfolioData.id ? true : false}   
                                value={portfolioData.subportfolio_name}
                                placeholder={"Nombre del subportafolio"}
                                variant="standard"
                                InputProps={{
                                    readOnly: portfolioData.id ? true : false,
                                    className:portfolioData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setPortfolioData({...portfolioData, subportfolio_name: e.target.value})}                            
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Descripción:</Typography>
                        </Grid>
                        <Grid item>
                            <CodeIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField          
                                value={portfolioData.description}
                                placeholder={"Ingresa una descripción"}
                                variant="standard"
                                InputProps={{
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setPortfolioData({...portfolioData, description: e.target.value})}                            
                            />
                        </Grid>                    
                    </Grid>                                       
                </Grid>     

                <Grid item xs={6}>
                    <Grid container spacing={2}>                        

                        < Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Metodología Comercialización:</Typography>
                        </Grid>
                        <Grid item>
                            <AttachMoneyIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                disabled={portfolioData.id ? true : false}   
                                select
                                value={portfolioData.c_calc_name}
                                placeholder={"Selecciona una opción"}
                                variant="standard"
                                InputProps={{
                                    readOnly: portfolioData.id ? true : false,
                                    className:portfolioData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setPortfolioData({...portfolioData, c_calc_name: e.target.value})}                            
                            >
                                {
                                    comCalcMethods.map((option, idx) => (
                                        <MenuItem key={idx} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Metodología Generación:</Typography>
                        </Grid>
                        <Grid item>
                            <AttachMoneyIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                disabled={portfolioData.id ? true : false}   
                                select
                                value={portfolioData.g_calc_name}
                                placeholder={"Selecciona una opción"}
                                variant="standard"
                                InputProps={{
                                    readOnly: portfolioData.id ? true : false,
                                    className:portfolioData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setPortfolioData({...portfolioData, g_calc_name: e.target.value})}                            
                            >
                                {
                                    genCalcMethods.map((option, idx) => (
                                        <MenuItem key={idx} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Permite agrupar:</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Switch
                                disabled={portfolioData.id ? true : false}
                                checked={portfolioData.group_allowed}
                                onChange={(e) => setPortfolioData({...portfolioData, group_allowed: e.target.checked})}
                                color="primary"                                                 
                            />
                            {portfolioData.group_allowed? 'Si':'No'}
                        </Grid> 
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Estado:</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Switch
                                checked={portfolioData.active}
                                onChange={(e) => setPortfolioData({...portfolioData, active: e.target.checked})}
                                color="primary"                                                 
                            />
                            {portfolioData.active? 'Activo':'Inactivo'}
                        </Grid> 
                        
                    </Grid>                    
                </Grid>                           
                <Grid item>
                     <Fab
                        color="secondary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"                        
                        classes={{root: classes.uploadButton}}
                        onClick={handleActorUpload}
                        style={{marginTop: 20}}
                    > 
                        <Fragment><SaveIcon /> {' Guardar  '}</Fragment>                         
                    </Fab>
                </Grid>                   
                <Grid item>
                    <Fab
                        color="secondary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"                        
                        classes={{root: classes.uploadButton}}
                        onClick={handleActorDialogClose}
                        style={{marginTop: 20}}
                    > 
                        <Fragment><CancelIcon /> {'Cancelar'}</Fragment>                         
                    </Fab>
                </Grid>
            </Grid>            
        </DialogContent>        
      </Dialog>
    )

    useEffect (() => {
        document.title ="Parametrización de subportafolios";
        
        authFetch("/api/check-portfolios-list?username="+props.username).then(response => {
            if (response.status === 422){
                    logout()
                    return null
                }
                return response.json()
            }).then(response => {
                if (response && response.portfolios){                    
                    setPortfoliosList(response.portfolios)                                        
                }
            })

        authFetch("/api/check-calc-methods?username="+props.username+"&user_type="+props.user_type).then(response => {
            if (response.status === 422){
                    logout()
                    return null
                }
                return response.json()
            }).then(response => {
                if (response && response.methods){          
                    let comCalcMethods = response.methods.filter(obj => obj.affected_var === 'Comercialización')
                    console.log(comCalcMethods)
                    let comCalcMethodsNames = comCalcMethods.map(obj => obj.calc_name)
                    console.log(comCalcMethodsNames)
                    setComCalcMethods([...comCalcMethodsNames])
                    let genCalcMethods = response.methods.filter(obj => obj.affected_var === 'Generación')
                    let genCalcMethodsNames = genCalcMethods.map(obj => obj.calc_name)
                    setGenCalcMethods(genCalcMethodsNames)
                }
            })
        
    }, [])

    return (
        <div className={classes.root}>
            {showActorDialog()}
            {showFeedbackDialog()}
            <Grid container justify="space-evenly">
                <Zoom in timeout={800}>
                        <Grid item xs={11}>
                            <Typography variant="subtitle1" className={classes.sectionTitle}>Parametrización de portafolios:</Typography>
                            <TableContainer component={Paper}>
                                <Table aria-label="markets table">
                                    <TableHead>
                                    <TableRow>                                        
                                        <StyledTableCell align="center" style={{width: "15%"}}>Portafolio</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Subportafolio</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "20%"}}>Descripción</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Metodología Comercialización</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Metodología Generación</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Estado</StyledTableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>                                           
                                        {portfoliosList.map((row,idx) => (
                                        <StyledTableRow 
                                            key={idx} 
                                            onClick={() => {updateValuesWithSelectedActor(idx); handleActorDialogOpen();}}
                                        >                                                       
                                            <StyledTableCell align="center" >{row.name}</StyledTableCell>
                                            <StyledTableCell align="center">{row.subportfolio_name}</StyledTableCell>
                                            <StyledTableCell align="center">{row.description}</StyledTableCell>
                                            <StyledTableCell align="center">{row.c_calc_name}</StyledTableCell>
                                            <StyledTableCell align="center">{row.g_calc_name}</StyledTableCell>
                                            <StyledTableCell align="center">{row.active ? 'Activo':'Inactivo'}</StyledTableCell>                                            
                                        </StyledTableRow>
                                            
                                        ))}                                            
                                    </TableBody>
                                </Table>
                            </TableContainer> 
                            <Fab
                                color="primary"
                                size="small"
                                component="span"
                                aria-label="add"
                                variant="extended"                        
                                classes={{root: classes.uploadButton}}
                                onClick={() =>{updateValuesWithSelectedActor(-1); handleActorDialogOpen();}}
                                style={{marginTop: 20}}
                            > 
                                <Fragment><AddIcon /> {' Agregar '}</Fragment>                         
                            </Fab>      
                        </Grid>                                                        
                </Zoom>                
            </Grid>       
        </div>
    );
}